import React from 'react';
import { ToastContext } from '@/contexts/Toast';

export const useToast = () => React.useContext(ToastContext);
